<template>
  <router-view />
  <InteractiveTestRunner
    v-model="testStore.isOpen"
    :title="testStore.title"
    :steps="testStore.steps"
    :current-step-index="testStore.currentStepIndex"
    :is-running="testStore.isRunning"
    v-model:is-paused="testStore.isPaused"
    :logs="testStore.globalLogs"
    :passed-count="testStore.passedCount"
    :failed-count="testStore.failedCount"
    :total-duration-ms="testStore.totalDurationMs"
    v-model:speed-ms="testStore.speedMs"
    @run="testStore.runTest"
    @reset="testStore.resetTest"
  />
</template>

<script setup lang="ts">
import InteractiveTestRunner from "./components/InteractiveTestRunner.vue";
import { useInteractiveTestStore } from "./stores/interactiveTestStore";

const testStore = useInteractiveTestStore();
</script>
